// extracted by mini-css-extract-plugin
export default {"flex":"Main_flex__3RX5E","main":"Main_main__i5VFi","type-writer":"Main_type-writer__3+QI-","main__title":"Main_main__title__EoY1E","main__arrow":"Main_main__arrow__6i8zq"};